// actions/identity/guestDocumentActions.ts
export const FETCH_PASSPORT_DATA_REQUEST = 'FETCH_PASSPORT_DATA_REQUEST';
export const FETCH_PASSPORT_DATA_SUCCESS = 'FETCH_PASSPORT_DATA_SUCCESS';
export const FETCH_PASSPORT_DATA_FAILURE = 'FETCH_PASSPORT_DATA_FAILURE';

export const FETCH_GUEST_DATA_REQUEST = 'FETCH_GUEST_DATA_REQUEST';
export const FETCH_GUEST_DATA_SUCCESS = 'FETCH_GUEST_DATA_SUCCESS';
export const FETCH_GUEST_DATA_FAILURE = 'FETCH_GUEST_DATA_FAILURE';

export const SAVE_GUEST_DOCUMENT_REQUEST = 'SAVE_GUEST_DOCUMENT_REQUEST';
export const SAVE_GUEST_DOCUMENT_SUCCESS = 'SAVE_GUEST_DOCUMENT_SUCCESS';
export const SAVE_GUEST_DOCUMENT_FAILURE = 'SAVE_GUEST_DOCUMENT_FAILURE';

export const DELETE_SINGLE_DOCUMENT_REQUEST = 'DELETE_SINGLE_DOCUMENT_REQUEST';
export const DELETE_SINGLE_DOCUMENT_SUCCESS = 'DELETE_SINGLE_DOCUMENT_SUCCESS';
export const DELETE_SINGLE_DOCUMENT_FAILURE = 'DELETE_SINGLE_DOCUMENT_FAILURE';

export const DELETE_GROUP_DOCUMENT_REQUEST = 'DELETE_GROUP_DOCUMENT_REQUEST';
export const DELETE_GROUP_DOCUMENT_SUCCESS = 'DELETE_GROUP_DOCUMENT_SUCCESS';
export const DELETE_GROUP_DOCUMENT_FAILURE = 'DELETE_GROUP_DOCUMENT_FAILURE';

export const DELETE_MORE_GUEST_REQUEST = 'DELETE_MORE_GUEST_REQUEST';
export const DELETE_MORE_GUEST_SUCCESS = 'DELETE_MORE_GUEST_SUCCESS';
export const DELETE_MORE_GUEST_FAILURE = 'DELETE_MORE_GUEST_FAILURE';

export const SCAN_PASSPORT_REQUEST = 'SCAN_PASSPORT_REQUEST';
export const SCAN_PASSPORT_SUCCESS = 'SCAN_PASSPORT_SUCCESS';
export const SCAN_PASSPORT_FAILURE = 'SCAN_PASSPORT_FAILURE';

export const SCAN_ID_CARD_REQUEST = 'SCAN_ID_CARD_REQUEST';
export const SCAN_ID_CARD_SUCCESS = 'SCAN_ID_CARD_SUCCESS';
export const SCAN_ID_CARD_FAILURE = 'SCAN_ID_CARD_FAILURE';
export const CLEAR_SCAN_ID_CARD_STATE = 'CLEAR_SCAN_ID_CARD_STATE';

// Interfaces
export interface FetchPassportDataRequestAction {
  type: typeof FETCH_PASSPORT_DATA_REQUEST;
  payload: { isAssigned: boolean };
}

export interface ClearScanIdCardStateAction {
  type: typeof CLEAR_SCAN_ID_CARD_STATE;
}

export interface FetchPassportDataSuccessAction {
  type: typeof FETCH_PASSPORT_DATA_SUCCESS;
  payload: { [key: string]: any[] };
}

export interface FetchPassportDataFailureAction {
  type: typeof FETCH_PASSPORT_DATA_FAILURE;
  payload: string;
}

export interface FetchGuestDataRequestAction {
  type: typeof FETCH_GUEST_DATA_REQUEST;
  payload: { arrivalDate?: string };
}

export interface FetchGuestDataSuccessAction {
  type: typeof FETCH_GUEST_DATA_SUCCESS;
  payload: any[];
}

export interface FetchGuestDataFailureAction {
  type: typeof FETCH_GUEST_DATA_FAILURE;
  payload: string;
}

export interface SaveGuestDocumentRequestAction {
  type: typeof SAVE_GUEST_DOCUMENT_REQUEST;
  payload: {
    tempGuestData: any[];
    tempMoreGuestData: any[];
    arrivalDateState: string | null;
    selectedDate: any;
    isUpdateMoreGuest: boolean;
  };
}

export interface SaveGuestDocumentSuccessAction {
  type: typeof SAVE_GUEST_DOCUMENT_SUCCESS;
  payload: { message: string; arrivalDate?: string };
}

export interface SaveGuestDocumentFailureAction {
  type: typeof SAVE_GUEST_DOCUMENT_FAILURE;
  payload: string;
}

export interface DeleteSingleDocumentRequestAction {
  type: typeof DELETE_SINGLE_DOCUMENT_REQUEST;
  payload: { groupKey: string; guestDocId: number };
}

export interface DeleteSingleDocumentSuccessAction {
  type: typeof DELETE_SINGLE_DOCUMENT_SUCCESS;
  payload: { groupKey: string; guestDocId: number };
}

export interface DeleteSingleDocumentFailureAction {
  type: typeof DELETE_SINGLE_DOCUMENT_FAILURE;
  payload: string;
}

export interface DeleteGroupDocumentRequestAction {
  type: typeof DELETE_GROUP_DOCUMENT_REQUEST;
  payload: { groupKey: string; itemsToDelete: any[] };
}

export interface DeleteGroupDocumentSuccessAction {
  type: typeof DELETE_GROUP_DOCUMENT_SUCCESS;
  payload: { groupKey: string };
}

export interface DeleteGroupDocumentFailureAction {
  type: typeof DELETE_GROUP_DOCUMENT_FAILURE;
  payload: string;
}

export interface DeleteMoreGuestRequestAction {
  type: typeof DELETE_MORE_GUEST_REQUEST;
  payload: { registerId: number; guestId: number; arrivalDate: string };
}

export interface DeleteMoreGuestSuccessAction {
  type: typeof DELETE_MORE_GUEST_SUCCESS;
  payload: { registerId: number; guestId: number };
}

export interface DeleteMoreGuestFailureAction {
  type: typeof DELETE_MORE_GUEST_FAILURE;
  payload: string;
}

export interface ScanPassportRequestAction {
  type: typeof SCAN_PASSPORT_REQUEST;
  payload: { tagName?: string; groupTagPassport: string };
}

export interface ScanPassportSuccessAction {
  type: typeof SCAN_PASSPORT_SUCCESS;
  payload: any;
}

export interface ScanPassportFailureAction {
  type: typeof SCAN_PASSPORT_FAILURE;
  payload: string;
}

export interface ScanIdCardRequestAction {
  type: typeof SCAN_ID_CARD_REQUEST;
  payload: { tagName?: string; groupTagPassport: string };
}

export interface ClearScanIdCardStateAction {
  type: typeof CLEAR_SCAN_ID_CARD_STATE;
}

export interface ScanIdCardSuccessAction {
  type: typeof SCAN_ID_CARD_SUCCESS;
  payload: any;
}

export interface ScanIdCardFailureAction {
  type: typeof SCAN_ID_CARD_FAILURE;
  payload: string;
}

export type GuestDocumentActionTypes =
  | FetchPassportDataRequestAction
  | FetchPassportDataSuccessAction
  | FetchPassportDataFailureAction
  | FetchGuestDataRequestAction
  | FetchGuestDataSuccessAction
  | FetchGuestDataFailureAction
  | SaveGuestDocumentRequestAction
  | SaveGuestDocumentSuccessAction
  | SaveGuestDocumentFailureAction
  | DeleteSingleDocumentRequestAction
  | DeleteSingleDocumentSuccessAction
  | DeleteSingleDocumentFailureAction
  | DeleteGroupDocumentRequestAction
  | DeleteGroupDocumentSuccessAction
  | DeleteGroupDocumentFailureAction
  | DeleteMoreGuestRequestAction
  | DeleteMoreGuestSuccessAction
  | DeleteMoreGuestFailureAction
  | ScanPassportRequestAction
  | ScanPassportSuccessAction
  | ScanPassportFailureAction
  | ScanIdCardRequestAction
  | ScanIdCardSuccessAction
  | ScanIdCardFailureAction
  | ClearScanIdCardStateAction;

// Action Creators
export const fetchPassportDataRequest = (isAssigned: boolean): FetchPassportDataRequestAction => ({
  type: FETCH_PASSPORT_DATA_REQUEST,
  payload: { isAssigned },
});

export const fetchPassportDataSuccess = (data: { [key: string]: any[] }): FetchPassportDataSuccessAction => ({
  type: FETCH_PASSPORT_DATA_SUCCESS,
  payload: data,
});

export const fetchPassportDataFailure = (error: string): FetchPassportDataFailureAction => ({
  type: FETCH_PASSPORT_DATA_FAILURE,
  payload: error,
});

export const fetchGuestDataRequest = (arrivalDate?: string): FetchGuestDataRequestAction => ({
  type: FETCH_GUEST_DATA_REQUEST,
  payload: { arrivalDate },
});

export const fetchGuestDataSuccess = (data: any[]): FetchGuestDataSuccessAction => ({
  type: FETCH_GUEST_DATA_SUCCESS,
  payload: data,
});

export const fetchGuestDataFailure = (error: string): FetchGuestDataFailureAction => ({
  type: FETCH_GUEST_DATA_FAILURE,
  payload: error,
});

export const saveGuestDocumentRequest = (payload: SaveGuestDocumentRequestAction['payload']): SaveGuestDocumentRequestAction => ({
  type: SAVE_GUEST_DOCUMENT_REQUEST,
  payload,
});

export const saveGuestDocumentSuccess = (payload: { message: string; arrivalDate?: string }): SaveGuestDocumentSuccessAction => ({
  type: SAVE_GUEST_DOCUMENT_SUCCESS,
  payload,
});

export const saveGuestDocumentFailure = (error: string): SaveGuestDocumentFailureAction => ({
  type: SAVE_GUEST_DOCUMENT_FAILURE,
  payload: error,
});

export const deleteSingleDocumentRequest = (groupKey: string, guestDocId: number): DeleteSingleDocumentRequestAction => ({
  type: DELETE_SINGLE_DOCUMENT_REQUEST,
  payload: { groupKey, guestDocId },
});

export const deleteSingleDocumentSuccess = (groupKey: string, guestDocId: number): DeleteSingleDocumentSuccessAction => ({
  type: DELETE_SINGLE_DOCUMENT_SUCCESS,
  payload: { groupKey, guestDocId },
});

export const deleteSingleDocumentFailure = (error: string): DeleteSingleDocumentFailureAction => ({
  type: DELETE_SINGLE_DOCUMENT_FAILURE,
  payload: error,
});

export const deleteGroupDocumentRequest = (groupKey: string, itemsToDelete: any[]): DeleteGroupDocumentRequestAction => ({
  type: DELETE_GROUP_DOCUMENT_REQUEST,
  payload: { groupKey, itemsToDelete },
});

export const deleteGroupDocumentSuccess = (groupKey: string): DeleteGroupDocumentSuccessAction => ({
  type: DELETE_GROUP_DOCUMENT_SUCCESS,
  payload: { groupKey },
});

export const deleteGroupDocumentFailure = (error: string): DeleteGroupDocumentFailureAction => ({
  type: DELETE_GROUP_DOCUMENT_FAILURE,
  payload: error,
});

export const deleteMoreGuestRequest = (registerId: number, guestId: number, arrivalDate: string): DeleteMoreGuestRequestAction => ({
  type: DELETE_MORE_GUEST_REQUEST,
  payload: { registerId, guestId, arrivalDate },
});

export const deleteMoreGuestSuccess = (registerId: number, guestId: number): DeleteMoreGuestSuccessAction => ({
  type: DELETE_MORE_GUEST_SUCCESS,
  payload: { registerId, guestId },
});

export const deleteMoreGuestFailure = (error: string): DeleteMoreGuestFailureAction => ({
  type: DELETE_MORE_GUEST_FAILURE,
  payload: error,
});

export const scanPassportRequest = (tagName: string | undefined, groupTagPassport: string): ScanPassportRequestAction => ({
  type: SCAN_PASSPORT_REQUEST,
  payload: { tagName, groupTagPassport },
});

export const scanPassportSuccess = (data: any): ScanPassportSuccessAction => ({
  type: SCAN_PASSPORT_SUCCESS,
  payload: data,
});

export const scanPassportFailure = (error: string): ScanPassportFailureAction => ({
  type: SCAN_PASSPORT_FAILURE,
  payload: error,
});

export const scanIdCardRequest = (tagName: string, groupTagPassport: string): ScanIdCardRequestAction => ({
  type: SCAN_ID_CARD_REQUEST,
  payload: { tagName, groupTagPassport },
});

export const clearScanIdCardState = (): ClearScanIdCardStateAction => ({
  type: CLEAR_SCAN_ID_CARD_STATE,
});

export const scanIdCardSuccess = (data: any): ScanIdCardSuccessAction => ({
  type: SCAN_ID_CARD_SUCCESS,
  payload: data,
});

export const scanIdCardFailure = (error: string): ScanIdCardFailureAction => ({
  type: SCAN_ID_CARD_FAILURE,
  payload: error,
});

